module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "background": "#f8f8f8",
      "padding": "0.2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onConfirm
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "添加证件照片(2寸)"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传2寸免冠照,此照片用于证书粘贴打印")]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "clearable": "",
      "left-icon": "question-o",
      "rules": [{
        required: true,
        message: '请输入尺码'
      }],
      "label": "衣服尺码",
      "placeholder": "请输入尺码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.cSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), (_vm.row.saiqu.class_type == 'C') ? _c('van-field', {
    attrs: {
      "clearable": "",
      "rules": [{
        required: true,
        message: '请输入鞋码'
      }],
      "error-message-align": "right",
      "label": "鞋  码",
      "placeholder": "请输入鞋码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.fSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.class_type == 'C') ? _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": function($event) {
        _vm.fSizeShow = true
      }
    }
  }, [_vm._v("查看鞋码表")]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "clearable": "",
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系方式",
      "placeholder": "请输入手机号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "衣服尺码表"
    },
    model: {
      value: (_vm.cSizeShow),
      callback: function($$v) {
        _vm.cSizeShow = $$v
      },
      expression: "cSizeShow"
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "鞋码表"
    },
    model: {
      value: (_vm.fSizeShow),
      callback: function($$v) {
        _vm.fSizeShow = $$v
      },
      expression: "fSizeShow"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16e13db8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cba/CbaApplyMemberDetail.vue
// module id = 2233
// module chunks = 0